function isSerializeValue(value) {
  try {
    JSON.stringify(value);
    return true;
  } catch (e) {
    return false;
  }
}
class Persistent {
  constructor(key, _value, typeAssertion) {
    this.key = key;
    this._value = _value;
    this.typeAssertion = typeAssertion;
    this._value = _value;
    this.typeAssertion = typeAssertion;
  }
}

export { Persistent, isSerializeValue };
